/**
 * Token-consuming operation key → Türkçe etiket eşlemesi.
 * Server `src/shared/i18n/operation-labels.js` ile birebir aynı tutulmalıdır.
 * Kullanıldığı yerler: TokenTab (Tip Dağılımı, En Çok Tüketim, Token Tüketim Şablonu),
 * Dashboard (Son İşlemler), FinancialTab (En Çok Kullanılan İşlemler).
 */
export const OPERATION_LABELS = {
  // ─── Hasta ────────────────────────────────────────────────────────
  "patients:create": "Hasta oluşturuldu",
  "patients:update": "Hasta bilgileri güncellendi",
  "patients:delete": "Hasta silindi",
  "patients:assign": "Hasta kliniğe atandı",
  "patients:suspend": "Hasta hesabı askıya alındı",
  "patients:freeze": "Hasta hesabı donduruldu",
  "patients:disable": "Hasta hesabı devre dışı bırakıldı",
  "patients:activate": "Hasta hesabı aktifleştirildi",
  "patients:bulk-save": "Toplu hasta kaydı yapıldı",

  // ─── Randevu ──────────────────────────────────────────────────────
  "appointments:create": "Randevu oluşturuldu",
  "appointments:update-details": "Randevu detayları güncellendi",
  "appointments:update-lab-tests": "Randevu tetkikleri güncellendi",
  "appointments:cancel": "Randevu iptal edildi",
  "appointments:delete": "Randevu silindi",

  // ─── Muayene ──────────────────────────────────────────────────────
  "examinations:create": "Muayene başlatıldı",
  "examinations:complete": "Muayene tamamlandı",
  "examinations:cancel": "Muayene iptal edildi",

  // ─── Anamnez ──────────────────────────────────────────────────────
  "anamnez:create": "Anamnez oluşturuldu",
  "anamnez:update": "Anamnez güncellendi",
  "anamnez:delete": "Anamnez silindi",

  // ─── Tetkik ───────────────────────────────────────────────────────
  "tetkik:create": "Tetkik oluşturuldu",
  "tetkik:update": "Tetkik güncellendi",
  "tetkik:delete": "Tetkik silindi",
  "tetkik:upload": "Tetkik dosyası yüklendi",

  // ─── Tedavi ───────────────────────────────────────────────────────
  "treatments:create": "Tedavi oluşturuldu",
  "treatments:update": "Tedavi güncellendi",
  "treatments:set-active": "Tedavi aktiflik durumu değiştirildi",
  "treatments:set-status": "Tedavi durumu güncellendi",
  "treatments:delete": "Tedavi silindi",

  // ─── Telefon görüşmesi ────────────────────────────────────────────
  "phoneCalls:create": "Telefon görüşmesi oluşturuldu",
  "phoneCalls:update": "Telefon görüşmesi güncellendi",
  "phoneCalls:delete": "Telefon görüşmesi silindi",

  // ─── Bildirim ─────────────────────────────────────────────────────
  "notifications:create": "Bildirim oluşturuldu",
  "notifications:update": "Bildirim güncellendi",
  "notifications:send": "Bildirim gönderildi",
  "notifications:delete": "Bildirim silindi",

  // ─── İlaç ─────────────────────────────────────────────────────────
  "medicines:create": "İlaç oluşturuldu",
  "medicines:update": "İlaç güncellendi",
  "medicines:delete": "İlaç silindi",

  // ─── Hastalık & diyet ─────────────────────────────────────────────
  "diseases:create-category": "Hastalık kategorisi oluşturuldu",
  "diseases:create-disease": "Hastalık oluşturuldu",
  "diet:create-category": "Diyet kategorisi oluşturuldu",
  "diet:create-item": "Diyet kalemi oluşturuldu",

  // ─── Klinik şablonları ────────────────────────────────────────────
  "doctorTemplates:medicines-create": "İlaç şablonu oluşturuldu",
  "doctorTemplates:medicines-update": "İlaç şablonu güncellendi",
  "doctorTemplates:medicines-status": "İlaç şablonu durumu değiştirildi",
  "doctorTemplates:diets-create": "Diyet şablonu oluşturuldu",
  "doctorTemplates:diets-update": "Diyet şablonu güncellendi",
  "doctorTemplates:diets-status": "Diyet şablonu durumu değiştirildi",
  "doctorTemplates:imaging-create": "Görüntüleme şablonu oluşturuldu",
  "doctorTemplates:imaging-update": "Görüntüleme şablonu güncellendi",
  "doctorTemplates:imaging-status": "Görüntüleme şablonu durumu değiştirildi",
  "doctorTemplates:labs-create": "Laboratuvar şablonu oluşturuldu",
  "doctorTemplates:labs-update": "Laboratuvar şablonu güncellendi",
  "doctorTemplates:labs-status": "Laboratuvar şablonu durumu değiştirildi",
  "doctorTemplates:examinations-create": "Muayene şablonu oluşturuldu",
  "doctorTemplates:examinations-update": "Muayene şablonu güncellendi",
  "doctorTemplates:examinations-status": "Muayene şablonu durumu değiştirildi",
  "doctorTemplates:diagnoses-create": "Tanı şablonu oluşturuldu",
  "doctorTemplates:diagnoses-update": "Tanı şablonu güncellendi",
  "doctorTemplates:diagnoses-status": "Tanı şablonu durumu değiştirildi",
  "doctorTemplates:complaints-create": "Şikayet şablonu oluşturuldu",
  "doctorTemplates:complaints-update": "Şikayet şablonu güncellendi",
  "doctorTemplates:complaints-status": "Şikayet şablonu durumu değiştirildi",

  // ─── Rol şablonları ───────────────────────────────────────────────
  "roleTemplates:create": "Rol şablonu oluşturuldu",
  "roleTemplates:update": "Rol şablonu güncellendi",
  "roleTemplates:delete": "Rol şablonu silindi",

  // ─── Bekleyen kullanıcılar ────────────────────────────────────────
  "pendingUsers:approve": "Bekleyen kullanıcı onaylandı",
  "pendingUsers:reject": "Bekleyen kullanıcı reddedildi",
  "pendingUsers:delete": "Bekleyen kullanıcı silindi",
  "pendingUsers:permanent-delete": "Bekleyen kullanıcı kalıcı silindi",

  // ─── Takvim & program ─────────────────────────────────────────────
  "schedule:resource-create": "Takvim kaynağı oluşturuldu",
  "schedule:resource-update": "Takvim kaynağı güncellendi",
  "schedule:update-settings": "Takvim ayarları güncellendi",

  // ─── Eski TokenTransaction tipleri ───────────────────────────────
  refund: "Token iadesi",
  consumption: "Token tüketimi",
  reload: "Token yüklemesi",
  adjustment: "Token düzeltmesi",
  Consumption: "Token tüketimi",
  GetReturn: "Token iadesi",
  Bill: "Token alımı",
  FreeUpload: "Ücretsiz token yüklemesi",
  Rollback: "İşlem geri alındı",
  Adjustment: "Token düzeltmesi",
};

const _LOWER_LOOKUP = Object.keys(OPERATION_LABELS).reduce((acc, k) => {
  acc[k.toLowerCase()] = OPERATION_LABELS[k];
  return acc;
}, {});

/**
 * Verilen operation key için Türkçe etiket döner.
 * Birebir eşleşme yoksa case-insensitive fallback uygular; yine bulamazsa raw key döner.
 */
export function getOperationLabel(key) {
  if (!key) return "";
  if (OPERATION_LABELS[key]) return OPERATION_LABELS[key];
  const lower = String(key).trim().toLowerCase();
  return _LOWER_LOOKUP[lower] || key;
}
